import React, { Component } from 'react'
import $ from 'jquery'
import Pagination from './Pagination.jsx';
import { apiClient } from "../helpers/common";
import swal from 'sweetalert';

class Category extends Component {

    constructor(props) {
        super(props);
        this.state = {
            totalRecords: 0,
            totalItems: [],
            pageOfItems: [],
            showPagination: true,
            category:'',
            category_id:'',
            isEdit:false
        };
    }
    componentDidMount() {
        if (sessionStorage.getItem('adminDetails') !== undefined && sessionStorage.getItem('adminDetails') !== null) {
            this.getCategoryList();
        } else {
            window.location.replace("/admin-login");
        }
    }
    componentDidUpdate() {

    }
    onChangePage = (items) => {
        this.setState({ pageOfItems: items });
    }
    getCategoryList = async () => {
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
        }

        const result = await apiClient('categories-listing', {
            method: 'POST',
            body: postData
        });

        if (result.status === 200) {
          this.setState({totalItems:result.data,totalRecords:result.data.length})
        }
    }

    getCategoryDetail = async (id) => {
        const {totalItems} = this.state
        let detail = totalItems.filter((val)=> { return val.uuid === id})
           
        this.setState({
            category:detail[0].category,
            category_id:detail[0].uuid,
            isEdit:true
        },()=>{
            window.$('#addCategoryPopup').modal('show')
        })
        
    }

    categoryListing = (data) => {
        if (data && data.length) {
            return (
                data.map((val, i) => {
                    return (
                        <tr key={i + 1} >
                            <td style={{ width: '20%' }}>{val.created_at}</td>
                            <td style={{ width: '10%' }}>{val.category}</td>
                            <td style={{ width: '20%' }}>{val.status === 'A' ? 'Active' :'' }</td>
                            <td style={{ width: '20%' }}>
                            <a href="javascript:void(0)" className="ml-3" onClick={() => this.getCategoryDetail(val.uuid)}><i className="fa fa-pencil"></i></a> &nbsp;&nbsp;
                              <a href="javascript:void(0)"  onClick={(e)=>this.handleDeleteAction(val.uuid)}><i className="fa fa-trash-o"></i></a>
                            </td>
                        </tr>
                    )
                })
            )
        } 
    }

    handleInputValue = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }  
    handleSubmit = async(e)=>{
        e.preventDefault();
        const {category,isEdit,category_id} = this.state

        if(isEdit){
            let postData = {
                token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
                category,
                uuid:category_id
            }
    
            const result = await apiClient('update-category', {
                method: 'POST',
                body: postData
            });
    
            if (result.status === 200) {
                this.setState({category:'',category_id:''})
                this.getCategoryList();
                window.$("#addCategoryPopup").modal('hide');
            }
        }else{
            let postData = {
                token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
                category
            }
    
            const result = await apiClient('add-category', {
                method: 'POST',
                body: postData
            });
    
            if (result.status === 200) {
                this.setState({category:''})
                this.getCategoryList();
                window.$("#addCategoryPopup").modal('hide');
            }
        }
      
    }

    handleDeleteAction=(id)=>{
        let postData = {
            token: JSON.parse(sessionStorage.getItem('adminDetails')).token,
            uuid: id,
        }
        swal({
            title: "Are you sure you want to delete this category?",
            closeOnClickOutside: false,
            buttons: true,
            dangerMode: true,
        }).then(async (isOk) => {
            if (isOk) {
                const result = await apiClient('delete-category', {
                    method: 'POST',
                    body: postData
                });

                if (result.status === 200) {
                    this.getCategoryList();
                }
            } else {
                console.log('you clicked on false');
            }
        });
    }

    refreshState =()=>{
        this.setState({
            category:'',
            category_id:'',
            isEdit:false
        })
    }
    
    render() {
        const { pageSize,isEdit } = this.state
  
        return (<>
            <div className="page_content">
             
                <section className="upper_section">
                    <div className="page_heading row">
                        <h3><span className="title">Categories</span></h3>
                        <div className="page_actions">
                        <a href="javascript:void(0)" className="ml-3" data-toggle="modal" data-target="#addCategoryPopup"><button type="submit" class="btn btn-default" onClick={()=>this.refreshState()}>Add Category</button></a>
                        </div>
                    </div>
                </section>
                <section class="lower_section">
                    <div class="row">
                        <div class="col-md-12 table-responsive  mt-3">
                            <div class="container-fluid bg-white p-0 mb-15 pb-0">
                                <table class="table table-striped table-bordered mb-0">
                                    <thead>
                                        <tr>
                                           
                                            <th style={{ width: '10%' }}>Created On</th>
                                            <th style={{ width: '10%' }}>Category</th>
                                            <th style={{ width: '10%' }}>Status</th>
                                            <th style={{ width: '10%' }}>Action</th>
                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.categoryListing(this.state.pageOfItems)}
                                    </tbody>
                                </table>
                                

                            </div>
                        </div>
                        <div className="col-md-12 pt-3 pagingWrap pb-3">
                            <div className="row">
                                {this.state.totalRecords > 0 ? <Pagination items={this.state.totalItems} onChangePage={this.onChangePage} /> : ''}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

             {/* add category */}
            <div className="modal fade smallmodalwrap " id="addCategoryPopup" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog smallmodal" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
               <h5 className="modal-title capcase mr-auto ng-binding">{isEdit ? 'Edit' :'Add'} Category</h5>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <form onSubmit ={(e)=>this.handleSubmit(e)}>
                                        <div className="form-group">
                                            <label className="labelMove">Category</label>
                                            <input type="text" name="category" value={this.state.category} onChange={(e) => this.handleInputValue(e)} className="form-control" required />
                                            {/* {this.validator.message('user_name', this.state.user_name,  { messages: { default: 'Name field is required.'} })} */}
                                        </div>
                                        
                                        <div className="row mt-3">
                                            <div className="col-md-12 text-right">
                                                <button type="button" data-dismiss="modal" className="btn-link">Cancel</button>
                                                <button type="submit" className="btn btn-green btn-mini float-right">{isEdit ? "Update":"Save"}</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer"></div>
                    </div>
                </div>
            </div>
        </>)
    }
}
export default Category